module.exports = __webpack_public_path__ + "img/stat-icon-3.e6e2011d.png";